import { GA_TRACKING_ID } from '@/lib/gtag'
import { YM_TRACKING_ID } from '@/lib/ym'

export const applyAnalytic = () => {
  const googleScript = document.createElement('script');
  googleScript.async = true;
  googleScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`

  const goodleDataLayerScript = document.createElement('script');
  goodleDataLayerScript.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_TRACKING_ID}', {
      page_path: window.location.pathname,
    });`

  const yandexScript = document.createElement('script');
  yandexScript.innerHTML = `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(${YM_TRACKING_ID}, "init", {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true
  });`;

  const yandexNoscript = document.createElement('noscript');
  yandexNoscript.innerHTML = `
  <div>
    <img
      src="https://mc.yandex.ru/watch/` + YM_TRACKING_ID + `
      style="position: absolute; left: -9999px
      alt=""
    ></img>
  </div>
  `;

  const facebookScript = document.createElement('script');
  facebookScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '721742175333234');
    fbq('track', 'PageView');
  `;

  const facebookNoScript = document.createElement('noscript');
  facebookNoScript.innerHTML = `
    <img style="display: none; width: 1px; height: 1px"
    src="https://www.facebook.com/tr?id=721742175333234&ev=PageView&noscript=1"></img>
  `

  document.head.append(googleScript, goodleDataLayerScript, yandexScript, yandexNoscript, facebookScript, facebookNoScript)

}